import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a550efa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/view/boxs-menu.scss?vue&type=style&index=0&id=6a550efa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a550efa",
  null
  
)

export default component.exports